import { fetchWrapper } from '../../../services/fetchServices/fetchWrapper';

export function deleteOrganization(id: number) {
  return fetchWrapper({
    url: `/api/organization/${id}`,
    fetchArg: {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  });
}
